export enum DismissStatus {
    IsSuspicious = 1,
    IsUnknown = 2,
    IsValid = 3
}
